import React from "react";
import { ButtonNew as Button } from "components/buttonNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import Input from "components/form/input/Input";
import { useTranslation } from "react-i18next";
import "components/switchUserModal/SwitchUserModal.scss";

interface IKioskLogoutModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
  okDisabled?: boolean;
  userCode: string;
  onChange: (e: any) => void;
  onKeyDown: (e: any) => void;
  autoFocus: boolean;
}

export default function KioskLogoutModal(props: IKioskLogoutModalProps) {
  const { t } = useTranslation();
  const { open, onCancel, onOk, okDisabled, userCode, onChange, onKeyDown, autoFocus } = props;

  if (!open) {
    return null;
  }

  return (
    <>
      <div className="switch-user-modal-container">
        <div className="switch-user-modal">
          <div className="switch-user-modal-header">
            <div className="switch-user-modal-header-title">{t("Staff Authorization")}</div>
            <Button
              className="switch-user-modal-header-close-button"
              icon={<FontAwesomeIcon icon={faTimes} />}
              type="text"
              onClick={onCancel}
            />
          </div>
          <div className="switch-user-modal-content">
            <p className="mb-4 text-gray-600">{t("Please enter your staff PIN to exit the kiosk and logout.")}</p>
            <div className="p-2">
              <Input
                label={t("Staff PIN")}
                value={userCode}
                onChange={onChange}
                onKeyDown={onKeyDown}
                autoFocus={autoFocus}
                type="password"
                autoComplete="new-password"
              />
            </div>
          </div>

          <div className="switch-user-modal-footer">
            <Button className="mr-2" type="default" onClick={onCancel}>
              {t("Cancel")}
            </Button>
            <Button type="primary" onClick={onOk} disabled={okDisabled}>
              {t("Authorize Logout")}
            </Button>
          </div>
        </div>
      </div>
      <div className="switch-user-modal-backdrop" onClick={onCancel} />
    </>
  );
}
